// extracted by mini-css-extract-plugin
module.exports = {"PassForm":"M4B55uY1","firstBlock":"_3O29o4iB","block":"_1wyd3Q9-","scrollDiv":"_1RuDEy_n","empty":"_200aevoU","emailLine":"_1R5XrkLq","label":"Lr1F0jBS","title":"_1u2eWKEk","titleBlock":"_1Mg2Bxk5","attribute":"_1o32zVWZ","value":"SwphopD8","submit":"_2PIVZl4k","input":"_25HWadzO","mainTitle":"_1w9JbMVX","subtitle":"_1OxGxN6e","text":"_3hx-lf4g","reasonText":"_RC2OYTJ","buttons":"_32Ihhjbv"};
    if(module.hot) {
      // 1754514929167
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  